import { FormElements } from '@custom-components';
import { PropTypes } from 'prop-types';
import React from 'react';
import { PortalButton } from '../PortalButton/PortalButton';

function FileUpload(props) {
  const { value, onChange, name, error, label, accept, required, errorText } = props;
  const inputRef = React.createRef();

  const uploadFile = () => {
    inputRef.current.click();
  };

  const acceptUploadedFile = () => {
    const file = inputRef.current.files[0];

    const fileReader = new FileReader();

    fileReader.addEventListener('load', () => {
      const document = {
        name: file.name.slice(0, file.name.lastIndexOf('.')),
        src: fileReader.result,
        date: file.lastModifiedDate.toString()
      };
      onChange({
        target: {
          name,
          value: document
        }
      });
    });

    fileReader.readAsDataURL(file);
  };

  const displayValue = value && value.name ? value.name : '';

  return (
    <>
      <input name={name} ref={inputRef} type="file" accept={accept} onChange={acceptUploadedFile} hidden />
      <div style={{ display: 'flex', alignItems: 'end' }}>
        <FormElements.TextInput
          name={name}
          label={label}
          value={displayValue}
          error={error}
          errorText={errorText}
          required={required}
          disabled
        />
        <div className="button" style={{ paddingLeft: 10, marginTop: 'auto' }}>
          <PortalButton label="UPLOAD" btnTheme="primary" onClick={uploadFile} />
        </div>
      </div>
    </>
  );
}

FileUpload.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    src: PropTypes.string,
    date: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  label: PropTypes.string.isRequired,
  accept: PropTypes.string,
  required: PropTypes.bool
};

FileUpload.defaultProps = {
  error: false,
  errorText: '',
  required: false,
  accept: 'application/pdf'
};

export default FileUpload;
